import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useGenerateReport = () => {
  const generateReport = async (payload) => {
    console.log(payload);
    const res = await api.post(`api/v1/trials/experiments/${payload.experiment_id}/report/generate`, JSON.stringify(payload));
    return res.json();
  };

  return useMutation(generateReport);
};

export default useGenerateReport;
